/** @format */

// src/index.js
import "./ui.scss";
import {createRoot} from "@wordpress/element";
import App from "./App.js";
import AdminExportScreen from "./components/AdminExportScreen.js"; // Import Screen Component
import FrontendDashboard from "./FrontendDashboard.js";
import MeetingView from "./components/MeetingView.jsx";

document.addEventListener("DOMContentLoaded", () => {
	// 1. Core Admin Verification App Screen View
	const adminRootElement = document.getElementById("amm-admin-app");
	if (adminRootElement) {
		const root = createRoot(adminRootElement);
		root.render(<App />);
	}

	// 2. New Isolated Dedicated Administration Export Tools Page Canvas Mount
	const exportRootElement = document.getElementById("amm-admin-export-root");
	if (exportRootElement) {
		const root = createRoot(exportRootElement);
		root.render(
			<div className="wrap">
				<h1 className="wp-heading-inline">Meeting Manager Export Desk</h1>
				<hr className="wp-header-end" />
				<AdminExportScreen />
			</div>,
		);
	}

	// 3. Frontend Dashboard App Mount
	const frontendRootElement = document.getElementById("amm-frontend-root");
	if (frontendRootElement) {
		const root = createRoot(frontendRootElement);
		root.render(<FrontendDashboard />);
	}

	// 4. Single Public Meeting Form Canvas Mount with Database Key Fallbacks
	const meetingRoot = document.getElementById("amm-meeting-root");
	if (meetingRoot) {
		// Fallback Matrix: checks 'data-meeting-post-id' first, then 'data-meeting-id'
		const rawMeetingPostId = meetingRoot.dataset.meetingPostId || meetingRoot.dataset.meetingId;

		// Final fallback to global variable scope context if DOM element reading is restricted
		const resolvedMeetingId = rawMeetingPostId || window.ammData?.current_meeting_id;

		if (!resolvedMeetingId) {
			console.error("Advanced MM Initialization Aborted: Public meeting wrapper target mounted without a valid tracking identification key.", "Verify HTML node attributes: data-meeting-post-id or data-meeting-id.");
			return;
		}

		const root = createRoot(meetingRoot);
		root.render(<MeetingView meetingPostId={resolvedMeetingId} />); // Changed from meetingId
	}
});
